import Vue from 'vue';

import {router} from '../../router';
import {i18n} from '../../plugins/i18n';

export default {
  state: {
    album: null,
    albums: null,
    allAlbums: null,
    groupedCategories: null,
    latestAlbums: null,
    albumCategories: null,
    albumPhotos: null,
    albumTag: null,
    loadingPhotosByParams: false,
  },
  getters: {
    ALBUM: state => {
      return state.album;
    },
    ALBUM_CATEGORIES: state => {
      return state.albumCategories;
    },
    ALBUMS: state => {
      return state.albums;
    },
    ALL_ALBUMS: state => {
      return state.allAlbums;
    },
    GROUPED_CATEGORIES: state => {
      return state.groupedCategories;
    },
    LATEST_ALBUMS: state => {
      return state.latestAlbums;
    },
    ALBUM_PHOTOS: state => {
      return state.albumPhotos;
    },
    ALBUM_TAG: state => {
      return state.albumTag;
    },
    LOADING_PHOTOS_BY_PARAMS: state => {
      return state.loadingPhotosByParams;
    },
  },
  mutations: {
    SET_ALBUM: (state, payload) => {
      state.album = payload;
    },
    SET_ALBUM_CATEGORIES: (state, payload) => {
      state.albumCategories = payload;
    },
    SET_ALBUMS: (state, payload) => {
      state.albums = payload;
    },
    SET_ALL_ALBUMS: (state, payload) => {
      state.allAlbums = payload;
    },
    SET_GROUPED_CATEGORIES: (state, payload) => {
      state.groupedCategories = payload;
    },
    SET_LATEST_ALBUMS: (state, payload) => {
      state.latestAlbums = payload;
    },
    SET_ALBUM_PHOTOS: (state, payload) => {
      state.albumPhotos = payload;
    },
    SET_ALBUM_TAG: (state, payload) => {
      state.albumTag = payload;
    },
    LOADING_PHOTOS_BY_PARAMS: (state, payload) => {
      state.loadingPhotosByParams = payload;
    },
  },
  actions: {
    INIT_ALBUM: async (context, id) => {
      let result = null;

      try {
        let tag = null;

        if (router.currentRoute.query.tag) {
          tag = router.currentRoute.query.tag;
        } else if (router.currentRoute.params.tag) {
          tag = router.currentRoute.params.tag;
        }

        context.commit('SET_ALBUM_TAG', tag);

        if (tag && tag.split('-').length > 1) {
          await context.dispatch('SAVE_PRIVATE_TAG', {albumHash: id, tagHash: tag});
        }

        let album = await Vue.axios.get(
            `v2/albums/${id}${tag ? `?tag=${tag}` : ''}`);

        if (album.data.success) {
          album = album && album.data ? album.data.data : null;

          if (album) {
            album.album_items = album.album_items && album.album_items.length > 0
                ? album.album_items
                : null;

            context.commit('SET_ALBUM_PHOTOS', album.album_items);
            context.dispatch('SET_COUPON', album.coupon ? album.coupon : null);
          }

          context.commit('SET_ALBUM', album);
          result = album;
        } else {
          return {error: true, message: album.data.message};
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
      }

      return result;
    },
    SET_ALBUM_CATEGORIES: async (context) => {
      try {
        const albumCategories = await Vue.axios.get('v2/album_categories');
        context.commit('SET_ALBUM_CATEGORIES', albumCategories.data.data);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
      }
    },
    INIT_ALBUMS: async (context, data) => {
      const loader = Vue.$loading.show();

      try {
        context.commit('SET_ALBUMS', null);
        const response = await Vue.axios.get(`v2/album_categories/${data.id}`);

        if (response) {
          context.commit('SET_ALBUMS', response.data.data.albums);
        } else {
          data.vm.toast(null, i18n.t('error'), 'danger');
        }

        loader.hide();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
        loader.hide();
      }
    },
    INIT_ALL_ALBUMS: async (context, data) => {
      const loader = Vue.$loading.show();

      try {
        context.commit('SET_ALL_ALBUMS', null);

        let params = [`page=${data.params.page || 1}`];

        if (data.params.categoryId) {
          params.push(`category=${data.params.categoryId}`)
        }

        if (data.params.year) {
          params.push(`year=${data.params.year}`)
        }

        const response = await Vue.axios.get(`v2/albums/paginate?${params.join('&')}`);

        if (response) {
          context.commit('SET_ALL_ALBUMS', response.data);
        } else {
          data.vm.toast(null, i18n.t('error'), 'danger');
        }

        loader.hide();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
        loader.hide();
      }
    },
    INIT_GROUPED_CATEGORIES: async (context) => {
      try {
        const response = await Vue.axios.get(`album_categories/get_grouped_by_year`);

        if (response && response.data && response.data.data) {
          context.commit('SET_GROUPED_CATEGORIES', response.data.data);
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
      }
    },
    INIT_LATEST_ALBUMS: async (context) => {
      try {
        const response = await Vue.axios.get(`albums/get_latest_albums`);

        if (response && response.data && response.data.data) {
          context.commit('SET_LATEST_ALBUMS', response.data.data);
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
      }
    },
    SET_ALBUM: (context, album) => {
      context.commit('SET_ALBUM', album);
    },
    SET_ALBUM_PHOTOS: (context, albumPhotos) => {
      context.commit('SET_ALBUM_PHOTOS', albumPhotos);
    },
    LOADING_PHOTOS_BY_PARAMS: (context, albumPhotos) => {
      context.commit('LOADING_PHOTOS_BY_PARAMS', albumPhotos);
    },
    SAVE_PRIVATE_TAG: async (context, data) => {
      if (await localStorage.getItem('private-tags')) {
        const privateTags = JSON.parse(await localStorage.getItem('private-tags'));

        if (privateTags[data.albumHash] && !privateTags[data.albumHash].includes(data.tagHash)) {
          privateTags[data.albumHash].push(data.tagHash);
        } else {
          privateTags[data.albumHash] = [data.tagHash]
        }

        await localStorage.setItem('private-tags', JSON.stringify(privateTags));
      } else {
        await localStorage.setItem('private-tags', JSON.stringify({
          [data.albumHash]: [data.tagHash]
        }));
      }

      Vue.axios.interceptors.request.use(config => {
        config.headers['X-bk-tags'] = localStorage.getItem('private-tags');
        return config;
      });
    },
  },
};